import React from 'react';
import { Box, Button, Typography, useTheme, useMediaQuery } from '@mui/material';
import img from './img/wpmarketingimg.png';
import Header from '../../../Header/Header';
import CompanySection from './CompanySection';
import UseWhatsAppMarketing from './UseWhatsAppMarketing';
import TextSection from './TextSection';
import CustomerSection from './CustomerSection';
import CustomerSection1 from './CustomerSection1';
import CustomerSection2 from './CustomerSection2';
import TextSection1 from './TextSection1';
import TextSection2 from './TextSection2';
import Customizesection from './Customizesection';
import Customerstory from './Customerstory';
import FooterSection from '../FooterSection';

const WhatsAppMarketing = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Header />

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: `url(bg2.svg)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    minHeight: '80vh',
                }}
            >
                <Box
                    sx={{
                        width: { xl: "74%", lg: "90%", md: "90%", sm: "90%" },
                        display: 'flex',
                        flexDirection: { xs: 'column-reverse', lg: 'row' },
                        p: { xs: 4, lg: 0 },
                    }}
                >
                    {/* Left Side */}
                    <Box
                        sx={{
                            width: { xs: '100%', lg: '50%' },
                            textAlign: { xs: 'center', lg: 'left' },
                        }}
                    >
                        <Typography
                            color="primary"
                            fontWeight={600}
                            sx={{
                                fontSize: { xs: '1.3rem', md: '3rem', lg: '1.3rem', xl: '3rem' },
                                mt: { xs: 2, lg: 0 },
                                color: '#28568f'
                            }}
                        >
                            WHATSAPP MARKETING SOFTWARE
                        </Typography>

                        <Typography
                            variant="h3"
                            fontWeight={700}
                            sx={{
                                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem', lg: '2.5rem', xl: '3rem' },
                                mt: 2,
                                display: { xs: 'none', md: 'block' }
                            }}
                        >
                            Get your campaign ROI in line with Vertex Suite WhatsApp marketing software
                        </Typography>

                        <Typography
                            variant="h3"
                            fontWeight={700}
                            sx={{
                                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                                mt: 2,
                                display: { xs: 'block', md: 'none' }
                            }}
                        >
                            Get your campaign ROI in line with Vertex Suite
                        </Typography>

                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{
                                mt: 3,
                                mb: 4,
                                maxWidth: 600,
                                fontSize: '18px'
                            }}
                        >
                            Grow faster with automated and personalized WhatsApp campaigns. Build and nurture a strong pipeline with Vertex Suite marketing automation software.
                        </Typography>

                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#28568f',
                                px: 3,
                                py: 1.5,
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                textTransform: 'none',
                                width: 'fit-content',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                '&:hover': { transform: 'scale(1.05)' },
                            }}
                        >
                            Start Free Trial ↗
                        </Button>
                    </Box>

                    {/* Right Side */}
                    <Box
                        sx={{
                            width: { xs: '100%', lg: '50%' },
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            src={img}
                            alt="WhatsApp Marketing"
                            style={{
                                width: isMobile ? '90%' : '75%', // slightly smaller on desktop
                                maxWidth: '500px',
                                height: 'auto',
                            }}
                        />
                    </Box>
                </Box>

            </Box>

            <CompanySection />
            <UseWhatsAppMarketing />
            <TextSection />
            <CustomerSection />
            <CustomerSection1 />
            <CustomerSection2 />
            {/* <TextSection1 /> */}
            <TextSection2 />
            <Customizesection />
            <Customerstory />
            <FooterSection/>
        </>
    );
};

export default WhatsAppMarketing;
